/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetResetTokenSubstitute200Response
 */
export interface GetResetTokenSubstitute200Response {
    /**
     * ステータス
     * @type {number}
     * @memberof GetResetTokenSubstitute200Response
     */
    status: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof GetResetTokenSubstitute200Response
     */
    message: string;
    /**
     * 発行トークン
     * @type {string}
     * @memberof GetResetTokenSubstitute200Response
     */
    adminToken: string;
}

/**
 * Check if a given object implements the GetResetTokenSubstitute200Response interface.
 */
export function instanceOfGetResetTokenSubstitute200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "adminToken" in value;

    return isInstance;
}

export function GetResetTokenSubstitute200ResponseFromJSON(json: any): GetResetTokenSubstitute200Response {
    return GetResetTokenSubstitute200ResponseFromJSONTyped(json, false);
}

export function GetResetTokenSubstitute200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetResetTokenSubstitute200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'adminToken': json['admin_token'],
    };
}

export function GetResetTokenSubstitute200ResponseToJSON(value?: GetResetTokenSubstitute200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'admin_token': value.adminToken,
    };
}

